/**
 * Feature Flag Registry
 *
 * Register feature flags here to make them available in the Feature Flag Manager
 * even before they exist in the backend. This allows frontend development to proceed
 * while backend feature flag implementation is pending.
 *
 * Usage:
 *   1. Add your flag to REGISTERED_FLAGS below
 *   2. Use checkFeatureFlag('your_flag_name') in your code
 *   3. Toggle the flag in Feature Flag Manager (Shift + Ctrl/Cmd + F)
 *
 * When the backend implements the flag, it will automatically take precedence
 * over the registered default value.
 */

export const REGISTERED_FLAGS = [
    {
        name: 'runbook_v2',
        description: 'Enables the new Playbooks listing (RunbookV2 table and side panel)',
        defaultEnabled: false,
    },
    // Add new feature flags here:
    // {
    //     name: 'your_feature_flag',
    //     description: 'Description of what this flag enables',
    //     defaultEnabled: false,
    // },
];

/**
 * Get all registered flag names
 */
export const getRegisteredFlagNames = () => {
    return REGISTERED_FLAGS.map((flag) => flag.name);
};

/**
 * Get registered flag metadata by name
 */
export const getRegisteredFlag = (flagName) => {
    return REGISTERED_FLAGS.find((flag) => flag.name === flagName);
};

/**
 * Check if a flag is registered (vs custom user-added)
 */
export const isRegisteredFlag = (flagName) => {
    return REGISTERED_FLAGS.some((flag) => flag.name === flagName);
};
